import * as THREE from 'three'
import LineSegments2 from '@glass-designer/library/three/LineSegments2'

export default class Line2 extends LineSegments2 {

	constructor( geometry, material) {
		super( geometry, material );
		this.type = 'Line2';

	}
}
